interface DataProps {
  id?: string;
  type: string;
  data: string[] | string;
  name: string;
}

interface BuildFunctionProps {
  state: DataProps;
  Element: any;
  isPoints?: boolean;
  dispensary?: string | null;
  isDispensary?: boolean; 
}

export const buildMap = ({ state, Element, isPoints = false, isDispensary = false }: BuildFunctionProps) => {
  const { data, name } = state;
  if (Array.isArray(data)) {
    const paths = data.map((d, i) => {
      return <path id={name} d={d} key={`${name}-${i}`} />;
    });
    return (
      <Element id={name} name={name} key={name} $isDispensary={isDispensary}>
        {paths}
      </Element>
    );
  }
  const d = isPoints ? { points: data } : { d: data };
  return <Element id={name} name={name} {...d} key={name} $isDispensary={isDispensary} />;
};
